import { render, staticRenderFns } from "./DifficultyLevelStars.vue?vue&type=template&id=7ade3e82"
import script from "./DifficultyLevelStars.vue?vue&type=script&lang=js"
export * from "./DifficultyLevelStars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports